import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

function holdRef(competitionId, holdDocId) {
  return doc(db, "competitions", competitionId, "allocationHolds", holdDocId);
}

function holdsCol(competitionId) {
  return collection(db, "competitions", competitionId, "allocationHolds");
}

/** @type {import('./allocationRepository.interface').AllocationRepository} */
export const firestoreAllocationRepository = {
  async getHold(competitionId, holdDocId) {
    const snap = await getDoc(holdRef(competitionId, holdDocId));
    return snap.exists() ? /** @type {import('../../domain/cmoe/allocation/allocationTypes').AllocationHold} */ (snap.data()) : null;
  },
  async saveHold(competitionId, hold) {
    await setDoc(holdRef(competitionId, hold.holdId), hold, { merge: true });
  },
  async listActiveHolds(competitionId) {
    const snap = await getDocs(holdsCol(competitionId));
    return snap.docs
      .map((d) => /** @type {import('../../domain/cmoe/allocation/allocationTypes').AllocationHold} */ (d.data()))
      .filter((h) => h.state === "held");
  },
};
